{
  "user_feedback.title": "Your experience matters to us. Would you like to submit feedback regarding this incident?",
  "user_feedback.subtitle": "We may contact you by email in case we need more details.",
  "user_feedback.consent.label": "Submit feedback?",
  "user_feedback.comments.label": "Feedback (optional)",
  "user_feedback.submitted": "Thank you for your cooperation in helping us resolve this issue promptly.",
  "user_feedback.declined": "Thank you for your feedback.",
  "user_feedback.contact_us": "Reach us in Discord in case you have more questions: <0 />",
  "version_notifier.deprecated.message": "Your version of the Wix CLI (<0>{currentVersion}</0>) is <1>deprecated</1>",
  "version_notifier.update.message": "Update available <0>{currentVersion}</0> -> <1>{latestVersion}</1>",
  "version_notifier.update.instructions": "Run <0>{packages}</0> to update"
}
